import { createContext, useContext } from 'react';
import { BranchSummary } from '../api/branches';

export interface BranchContextValue {
  branches: BranchSummary[];
  selectedBranchId: number | undefined;
  setSelectedBranchId: (branchId: number | undefined) => void;
}

export const BranchContext = createContext<BranchContextValue | undefined>(undefined);

export const useBranchFilter = () => {
  const ctx = useContext(BranchContext);
  if (!ctx) throw new Error('useBranchFilter must be used within a BranchProvider');
  return ctx;
};
